document.addEventListener('DOMContentLoaded',function(){
  var drawer=document.querySelector('.drawer'),scrim=document.querySelector('.drawer__scrim');
  function open(){drawer&&drawer.classList.add('is-open');scrim&&scrim.classList.add('is-open');}
  function close(){drawer&&drawer.classList.remove('is-open');scrim&&scrim.classList.remove('is-open');}
  document.addEventListener('click',function(e){
    if(e.target.closest('[data-cart-open]')){e.preventDefault();refresh();open();}
    if(e.target.closest('[data-cart-close]')||e.target===scrim){close();}
  });

  /* offer selection */
  var offers=document.querySelectorAll('.offer');
  offers.forEach(function(o){
    o.addEventListener('click',function(){
      offers.forEach(function(x){x.classList.remove('is-on');});
      o.classList.add('is-on');
      var input=o.querySelector('input');if(input)input.checked=true;
      var form=document.querySelector('[data-product-form]');
      if(form){
        form.querySelector('[name="id"]').value=o.dataset.variant;
        var q=form.querySelector('[name="quantity"]');if(q)q.value=o.dataset.qty||1;
      }
      document.querySelectorAll('[data-sel-title]').forEach(function(n){n.textContent=o.dataset.title;});
      document.querySelectorAll('[data-sel-supply]').forEach(function(n){n.textContent=o.dataset.supply;});
      document.querySelectorAll('[data-sel-price]').forEach(function(n){n.textContent=o.dataset.price;});
      document.querySelectorAll('[data-sel-save]').forEach(function(n){n.textContent=o.dataset.save;});
    });
  });

  /* gallery */
  var main=document.querySelector('[data-gallery-main]');
  document.querySelectorAll('[data-gallery-thumb]').forEach(function(t){
    t.addEventListener('click',function(){
      document.querySelectorAll('[data-gallery-thumb]').forEach(function(x){x.setAttribute('aria-current','false');});
      t.setAttribute('aria-current','true');
      if(main&&t.dataset.src)main.src=t.dataset.src;
    });
  });

  /* sticky bar */
  var bar=document.querySelector('.sticky-bar'),anchor=document.querySelector('.offers');
  if(bar&&anchor){
    window.addEventListener('scroll',function(){
      var r=anchor.getBoundingClientRect();
      var beforeFooter=(document.body.scrollHeight-window.scrollY-window.innerHeight)>400;
      bar.classList.toggle('is-on',r.bottom<60&&beforeFooter);
    },{passive:true});
  }

  /* ajax add to cart */
  var form=document.querySelector('[data-product-form]');
  if(form){
    form.addEventListener('submit',function(e){
      e.preventDefault();
      fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},
        body:JSON.stringify({id:form.querySelector('[name="id"]').value,quantity:form.querySelector('[name="quantity"]').value||1})})
        .then(function(){return refresh();}).then(open);
    });
  }
  document.querySelectorAll('[data-buy-scroll]').forEach(function(b){
    b.addEventListener('click',function(){
      var t=document.querySelector('.offers');
      if(t)window.scrollTo({top:t.getBoundingClientRect().top+window.scrollY-110,behavior:'smooth'});
    });
  });

  function refresh(){
    return fetch('/?section_id=cart-drawer').then(function(r){return r.text();}).then(function(html){
      var doc=new DOMParser().parseFromString(html,'text/html');
      var next=doc.querySelector('[data-cart-contents]');
      var cur=document.querySelector('[data-cart-contents]');
      if(next&&cur)cur.innerHTML=next.innerHTML;
      var c=doc.querySelector('[data-cart-count]');
      document.querySelectorAll('[data-cart-count]').forEach(function(n){if(c)n.textContent=c.textContent;});
    }).catch(function(){});
  }
});

/* reviews slider dots (mobile) */
(function(){
  document.querySelectorAll('[data-reviews-slider]').forEach(function(track){
    var dots = track.parentElement.querySelector('[data-slider-dots]');
    if(!dots) return;
    var cards = track.querySelectorAll('.review');
    if(cards.length < 2) return;
    function build(){
      if(dots.childElementCount === cards.length) return;
      dots.innerHTML = '';
      cards.forEach(function(c,i){
        var b = document.createElement('button');
        b.type = 'button';
        b.setAttribute('aria-label','Review ' + (i+1));
        b.setAttribute('aria-current', i === 0 ? 'true' : 'false');
        b.addEventListener('click', function(){ track.scrollTo({left: c.offsetLeft - track.offsetLeft, behavior: 'smooth'}); });
        dots.appendChild(b);
      });
    }
    build();
    var raf;
    track.addEventListener('scroll', function(){
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(function(){
        var mid = track.scrollLeft + track.clientWidth / 2, best = 0, bestD = Infinity;
        cards.forEach(function(c,i){
          var d = Math.abs((c.offsetLeft - track.offsetLeft) + c.clientWidth/2 - mid);
          if(d < bestD){ bestD = d; best = i; }
        });
        dots.querySelectorAll('button').forEach(function(b,i){ b.setAttribute('aria-current', i === best ? 'true' : 'false'); });
      });
    }, {passive:true});
  });
})();
